import { render } from "./CreateUserCompany.vue?vue&type=template&id=62cd6f2e&scoped=true"
import script from "./CreateUserCompany.vue?vue&type=script&lang=js"
export * from "./CreateUserCompany.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=62cd6f2e&scoped=true&lang=css&external"
import "./CreateUserCompany.vue?vue&type=style&index=1&id=62cd6f2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd6f2e"]])

export default __exports__